import { __decorate, __metadata } from "tslib";
import { AppRequestMethod } from '@core/shared/request';
import { AppRequest } from '@core/shared/app-request';
import { Expose, IsNumber, Model, ModelId, Structure } from '@core/shared/model';
import { ExamResultStatus } from '../models/exam-result.item';
let ExamProgressResponse = /*#__PURE__*/(() => {
  let ExamProgressResponse = class ExamProgressResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Number)], ExamProgressResponse.prototype, "examId", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], ExamProgressResponse.prototype, "courseId", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], ExamProgressResponse.prototype, "hasAdmission", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], ExamProgressResponse.prototype, "hasValidCertificate", void 0);
  __decorate([Expose(), __metadata("design:type", Boolean)], ExamProgressResponse.prototype, "showAsCompleted", void 0);
  __decorate([Expose(), __metadata("design:type", ExamResultStatus)], ExamProgressResponse.prototype, "examResultStatus", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamProgressResponse.prototype, "certificateDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamProgressResponse.prototype, "admissionDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], ExamProgressResponse.prototype, "lastPassedDate", void 0);
  ExamProgressResponse = __decorate([ModelId("ExamProgressResponse") // auto-generated by generate-model-ids
  ], ExamProgressResponse);
  return ExamProgressResponse;
})();
export { ExamProgressResponse };
let ExamProgressRequest = /*#__PURE__*/(() => {
  let ExamProgressRequest = class ExamProgressRequest extends Model {
    static {
      this.Response = ExamProgressResponse;
    }
  };
  __decorate([IsNumber(), Expose(), __metadata("design:type", Number)], ExamProgressRequest.prototype, "courseId", void 0);
  ExamProgressRequest = __decorate([AppRequest('courses', ':courseId/progress', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("ExamProgressRequest") // auto-generated by generate-model-ids
  ], ExamProgressRequest);
  return ExamProgressRequest;
})();
export { ExamProgressRequest };
let AllExamsProgressResponse = /*#__PURE__*/(() => {
  let AllExamsProgressResponse = class AllExamsProgressResponse extends Model {};
  __decorate([Expose(), Structure(Array, () => ExamProgressResponse), __metadata("design:type", Array)], AllExamsProgressResponse.prototype, "progress", void 0);
  AllExamsProgressResponse = __decorate([ModelId("AllExamsProgressResponse") // auto-generated by generate-model-ids
  ], AllExamsProgressResponse);
  return AllExamsProgressResponse;
})();
export { AllExamsProgressResponse };
let AllExamsProgressRequest = /*#__PURE__*/(() => {
  let AllExamsProgressRequest = class AllExamsProgressRequest extends Model {
    static {
      this.Response = AllExamsProgressResponse;
    }
  };
  AllExamsProgressRequest = __decorate([AppRequest('courses', 'progress-all', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("AllExamsProgressRequest") // auto-generated by generate-model-ids
  ], AllExamsProgressRequest);
  return AllExamsProgressRequest;
})();
export { AllExamsProgressRequest };
// @AppRequest('admin/courses', 'progress-all', {httpMethod:AppRequestMethod.POST})
// export class GetUserExamsProgressRequest extends Model {
// 	static Response = AllExamsProgressResponse
// 	@Expose()
// 	@IsNumber()
// 	userId:number
// }
let ExamProgressInternalRequest = /*#__PURE__*/(() => {
  let ExamProgressInternalRequest = class ExamProgressInternalRequest extends Model {
    static {
      this.Response = ExamProgressResponse;
    }
  };
  __decorate([IsNumber(), Expose(), __metadata("design:type", Number)], ExamProgressInternalRequest.prototype, "courseId", void 0);
  __decorate([IsNumber(), Expose(), __metadata("design:type", Number)], ExamProgressInternalRequest.prototype, "userId", void 0);
  ExamProgressInternalRequest = __decorate([AppRequest('courses', 'progress', {
    httpMethod: false
  }), ModelId("ExamProgressInternalRequest") // auto-generated by generate-model-ids
  ], ExamProgressInternalRequest);
  return ExamProgressInternalRequest;
})();
export { ExamProgressInternalRequest };